import _debounce from 'lodash/debounce';

// @vue/component
export default {
	data() {
		return {
			searchValue: '',
		};
	},
	computed: {
		search: {
			get() {
				return this.searchValue;
			},
			set(search) {
				this.searchValue = search || '';
				this.debouncedSearch(search);
			},
		},
	},
	methods: {
		debouncedSearch: _debounce(function find(search) {
			if (search.length >= 3) {
				this.$router.push({
					query: {
						...this.$route.query,
						search,
						page: undefined,
					},
				});
			} else {
				this.$router.push({
					query: {
						...this.$route.query,
						search: undefined,
						page: undefined,
					},
				});
			}
		}, 500),
	},
};
